import { c as _c } from "react/compiler-runtime";
import { Children, type CSSProperties, cloneElement, isValidElement, type ReactElement, useEffect, useState } from "react";
import { cn } from "@/lib/utils";
type FadeInChildProps = {
  className?: string;
  style?: CSSProperties;
  "data-visible"?: "true" | "false";
};
export default function FadeIn(t0) {
  const $ = _c(11);
  const {
    show: t1,
    duration: t2,
    children
  } = t0;
  const show = t1 === undefined ? true : t1;
  const duration = t2 === undefined ? 300 : t2;
  const [mounted, setMounted] = useState(show);
  const [visible, setVisible] = useState(show);
  let t3;
  let t4;
  if ($[0] !== duration || $[1] !== show) {
    t3 = () => {
      if (show) {
        setMounted(true);
        requestAnimationFrame(() => setVisible(true));
      } else {
        setVisible(false);
        const timeout = setTimeout(() => setMounted(false), duration);
        return () => clearTimeout(timeout);
      }
    };
    t4 = [show, duration];
    $[0] = duration;
    $[1] = show;
    $[2] = t3;
    $[3] = t4;
  } else {
    t3 = $[2];
    t4 = $[3];
  }
  useEffect(t3, t4);
  if (!mounted) {
    return null;
  }
  let t5;
  if ($[4] !== children || $[5] !== duration || $[6] !== visible) {
    let t6;
    if ($[8] !== duration || $[9] !== visible) {
      t6 = child => {
        if (!isValidElement(child)) {
          return child;
        }
        return cloneElement(child, {
          className: cn(child.props.className ?? "", "data-[visible=false]:opacity-0 transition-opacity ease-out", "data-[visible=true]:opacity-100"),
          style: {
            ...(child.props.style ?? {}),
            transitionDuration: `${duration}ms`
          } as CSSProperties,
          "data-visible": visible ? "true" : "false"
        });
      };
      $[8] = duration;
      $[9] = visible;
      $[10] = t6;
    } else {
      t6 = $[10];
    }
    t5 = Children.map(children, t6);
    $[4] = children;
    $[5] = duration;
    $[6] = visible;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  return t5;
}